
import { defineComponent, ref } from "vue";
import GalleryComponent from "@/components/Gallery.vue";
export default defineComponent({
  name: "Gallery",
  components: {
    GalleryComponent,
  },
  setup() {
    const imageList = ref([
      [
        "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Test-Logo.svg/783px-Test-Logo.svg.png",
        "https://images.sftcdn.net/images/t_app-cover-l,f_auto/p/befbcde0-9b36-11e6-95b9-00163ed833e7/260663710/the-test-fun-for-friends-screenshot.jpg",
        "https://assets.fireside.fm/file/fireside-images/podcasts/images/b/bc7f1faf-8aad-4135-bb12-83a8af679756/cover.jpg",
        "https://www.softwaretestingnews.co.uk/wp-content/uploads/2021/06/logo-copy-2-2-copy.png",
      ],
      [
        "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Test-Logo.svg/783px-Test-Logo.svg.png",
        "https://images.sftcdn.net/images/t_app-cover-l,f_auto/p/befbcde0-9b36-11e6-95b9-00163ed833e7/260663710/the-test-fun-for-friends-screenshot.jpg",
        "https://assets.fireside.fm/file/fireside-images/podcasts/images/b/bc7f1faf-8aad-4135-bb12-83a8af679756/cover.jpg",

      ],
    ]);
    return {
      imageList,
    };
  },
});
